import { Component, Inject, Injector, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractComponent, CustomField, CustomFieldScopeEnum, CustomFieldService, TypeFieldEnum } from 'lib-trend-core';

@Component({
    selector: 'custom-field-edit-component',
    // templateUrl: 'custom-field-edit.component.html',
    templateUrl: 'custom-field-edit.v2.component.html',
    styleUrls: ['custom-field-edit.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomFieldEditComponent extends AbstractComponent {
  fieldsCustom!: CustomField;
  listTypeField: Array<TypeFieldEnum> = new Array<TypeFieldEnum>(TypeFieldEnum.TEXT, TypeFieldEnum.NUMBER, TypeFieldEnum.FREETEXT, TypeFieldEnum.DATE);
  /** Which record the field belongs to (E2 RF-17): the contact, or the lead's qualification. */
  readonly scopes = [
    { value: CustomFieldScopeEnum.CONTACT, label: 'customField.edit.scopeContact' },
    { value: CustomFieldScopeEnum.CUSTOMER, label: 'customField.edit.scopeCustomer' },
  ];
  previewData: { name: string; type: string, description?: string } = { name: 'Exemplo', type: 'TEXT', description: '' };

  constructor(
    injector: Injector,
    public dialogRef: MatDialogRef<CustomFieldEditComponent>,
    private fieldsCustomService: CustomFieldService,
    @Inject(MAT_DIALOG_DATA) public data: CustomField,
  ) {
    super(injector);
    this.fieldsCustom = {} as CustomField;
    this.createForm();
  }

  ngOnInit() {
    this.isNew = (!!this.data ? false : true);

    if (!this.isNew) {
      this.fieldsCustom = { ...this.data };
      // Fixed at creation — the values live on the record the field belongs to (the API ignores it too).
      this.formGroup.get('scope')?.disable();
      this.formGroup.patchValue(this.data);
      this.updateValue(this.data);
    }
  }

  private createForm(): void {
    this.formGroup = this.formBuilder.group({
      name: [null, Validators.required],
      type: [TypeFieldEnum.TEXT],
      scope: [CustomFieldScopeEnum.CONTACT],
      description: [null]
    });

    this.formGroup.valueChanges.subscribe(value => {
      Object.assign(this.fieldsCustom, value);
      this.updateValue(value);
    });
  }

  private updateValue(value: any): void {
    this.previewData = {
      name: value.name,
      type: value.typeField,
      description: value.description || '',
    };
  }

  close(): void {
    this.dialogRef.close();
  }

  save() {
    if (!this.formGroup.valid) {
      this.validateAllFormFields(this.formGroup);
      return;
    }

    if (this.isNew) {
      this.fieldsCustomService.create(this.fieldsCustom).subscribe({
        next: (value) => {
          this.loading = false
          this.dialogRef.close(value);
          this.alertService.success(this.t('customField.edit.createSuccess'));
        },
      });
    } else {
      this.fieldsCustomService.update(this.fieldsCustom._id, this.fieldsCustom).subscribe({
        next: (value) => {
          this.loading = false
          this.dialogRef.close(value);
          this.alertService.success(this.t('customField.edit.updateSuccess'));
        },
      });
    }
  }
}
